import React, { forwardRef, useState } from 'react';
import { useIntl } from 'react-intl';
import CustomBtn from '../../../../generic/CustomBtn';
import PreviewSampleTree from '../PreviewSampleTree/PreviewSampleTree';
import { chooseColor } from '../../../../utils/helpers';

const PreviewSampleZone = forwardRef(({
  sampleName,
  sampleRadius,
  coordinates,
  sampleTrees,
  warning,
  isLastElem,
  isPreviousStage,
}, ref) => {
  const [hideElement, setHideElement] = useState(true);
  const translate = useIntl();
  const szRef = isLastElem ? { ref } : {};

  const roundToDecimals = (value) => value.toFixed(5);
  let stylesZone = `${chooseColor(sampleTrees)} sample-zone`;

  if (isPreviousStage) {
    stylesZone = 'sample-zone';
  }
  return (
    <div className={stylesZone} {...szRef}>
      <div className="sample-zone__header">
        <div className="sample-zone__header-name">
          <span>{sampleName}</span>
        </div>
        <div className="sample-zone__header-coord">
          <i className="icon-marker-circle" />
          <div className="sample-zone__header-coord-text">
            <span className="sample-zone__header-coord-title">
              {translate.formatMessage({ id: 'previewSampleZone.samplePlotCoordinates' })}
            </span>
            <span className="sample-zone__header-coord-value">
              {`${roundToDecimals(coordinates[0])}, ${roundToDecimals(coordinates[1])}`}
            </span>
          </div>
        </div>
        <div className="sample-zone__header-radius">
          <i className="icon-escalation-arrow" />
          <div className="sample-zone__header-radius-text">
            <span className="sample-zone__header-radius-title">
              {translate.formatMessage({ id: 'previewSampleZone.radius' })}
            </span>
            <span className="sample-zone__header-radius-value">
              {`${sampleRadius} m.`}
            </span>
          </div>
        </div>
        <div className="sample-zone__header-warning">
          {warning && (
            <>
              {warning.missingDescription && (
                <>
                  <i className="icon-exclamation" />
                  <span>
                    {translate.formatMessage({ id: 'previewSampleZone.missingInformation' })}
                  </span>
                </>
              )}
              {warning.missingLength && (
                <>
                  <i className="icon-exclamation" />
                  <span>
                    {translate.formatMessage({ id: 'previewSampleZone.atLeastOneTree' })}
                  </span>
                </>
              )}
            </>
          )}
        </div>
        <div className={`sample-zone__header-btn ${hideElement ? 'up' : 'dropdown'}`}>
          <CustomBtn
            iconClass="icon-left-arrow"
            handleClick={() => setHideElement(!hideElement)}
            customClass="sample-zone__btn"
          />
        </div>
      </div>
      <div className={`sample-zone__content ${hideElement ? 'up' : 'dropdown'}`}>
        <div className="content-header">
          <span className="header-tree">
            {translate.formatMessage({ id: 'previewSampleZone.tree' })}
          </span>
          <span className="header-status">
            {translate.formatMessage({ id: 'previewSampleZone.treeStatus' })}
          </span>
          <span className="header-height">
            {translate.formatMessage({ id: 'previewSampleZone.height' })}
          </span>
          <span className="header-diameter">
            {translate.formatMessage({ id: 'previewSampleZone.circumference' })}
          </span>
          <span className="header-tree-photo">
            {translate.formatMessage({ id: 'previewSampleZone.treePhoto' })}
          </span>
          <span className="header-label-photo">
            {translate.formatMessage({ id: 'previewSampleZone.treeTag' })}
          </span>
        </div>
        <div className="content-list">
          {sampleTrees.map((item) => (
            <PreviewSampleTree
              sampleName={sampleName}
              sampleTreeId={`T${item.id}`}
              treeName={item.treeName}
              status={item.status}
              height={item.height}
              diameter={item.diameter}
              treePhoto={item.treePhoto}
              labelPhoto={item.labelPhoto}
              key={`Tree${item.id}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
});

export default PreviewSampleZone;
